import React, { useState, useEffect } from "react";
import { useAppDispatch } from "../../../../../../app/redux/hooks";
import { setType } from "../../../LRPSlice";

function SwinePracticeAndTypeSelection({ types }) {
  const dispatch = useAppDispatch();
  const [selectedType, setSelectedType] = useState("");

  const handleSelect = (e) => {
    setSelectedType(e.target.value);
  };

  useEffect(() => {
    // Initilization
    setSelectedType(types[0]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(setType(selectedType));
  }, [selectedType, dispatch]);

  return (
    <div className="card w-100 p-3">
      <h5 className="card-title">Type</h5>
      <p className="card-text">Please select your insurance type.</p>
      <label>Type:</label>
      <select
        name="cattle_type"
        id="cattle_type"
        // className="form-control ag-form-focus col-4 pb-1 mb-1 btn-secondary mt-1"
        className="form-select text-white bg-secondary ag-form-focus col-4 pb-1 my-3"
        onChange={handleSelect}
        style={{ maxWidth: 360, minWidth: 150 }}
      >
        {types.map((type) => {
          return (
            <option value={type} key={type}>
              {type}
            </option>
          );
        })}
      </select>
    </div>
  );
}

export default SwinePracticeAndTypeSelection;
